export default __webpack_public_path__ + "static/media/guide0102.3d6b15f7.jpg";